import React from 'react';

const PremiumTableShell = ({
  summary,
  toolbarRight,
  loading,
  loadingText = 'Carregando...',
  tableMinWidth = 980,
  hideToolbar = false,
  children,
}) => (
  <>
    <style>{`
      .premium-table-shell {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .premium-table-card {
        background: rgba(255, 255, 255, 0.92);
        border: 1px solid rgba(148, 163, 184, 0.14);
        border-radius: 18px;
        box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
        overflow: hidden;
      }

      .premium-table-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        flex-wrap: wrap;
        padding: 14px 16px 10px;
        border-bottom: 1px solid rgba(226, 232, 240, 0.9);
      }

      .premium-table-toolbar-title {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .premium-table-toolbar-title p {
        margin: 0;
        color: #64748b;
        font-size: 12px;
      }

      .premium-table-toolbar-actions {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        justify-content: flex-end;
      }

      .premium-table-wrapper {
        position: relative;
        padding: 12px;
        overflow-x: auto;
      }

      .premium-table-wrapper .ReactTable {
        border: 0;
        min-width: var(--premium-table-min-width, 980px);
      }

      .premium-table-wrapper .ReactTable .rt-thead.-header {
        box-shadow: none;
        border-bottom: 1px solid #e2e8f0;
        background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
      }

      .premium-table-wrapper .ReactTable .rt-th,
      .premium-table-wrapper .ReactTable .rt-td {
        border-right: 0;
        padding: 5px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 32px;
        overflow: visible;
      }

      .premium-table-wrapper .ReactTable .rt-td.column_icon {
        padding: 3px 4px;
        min-height: 32px;
      }

      .premium-table-wrapper .ReactTable .rt-tr {
        align-items: center;
      }

      .premium-table-wrapper .ReactTable .rt-tbody .rt-tr-group,
      .premium-table-wrapper .ReactTable .rt-tbody .rt-tr {
        min-height: 32px;
      }

      .premium-table-wrapper .ReactTable .rt-th {
        color: #334155;
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.03em;
      }

      .premium-table-wrapper .ReactTable .rt-tr-group {
        border-bottom: 1px solid #eef2f7;
      }

      .premium-table-wrapper .ReactTable.-striped .rt-tr.-odd {
        background: #f2f6fb;
      }

      .premium-table-wrapper .ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
        background: rgba(59, 130, 246, 0.05);
      }

      .premium-table-wrapper .ReactTable .rt-thead.-filters {
        border-bottom: 1px solid #e2e8f0;
        background: #ffffff;
      }

      .premium-table-wrapper .ReactTable .rt-thead.-filters input,
      .premium-table-wrapper .ReactTable .rt-thead.-filters select {
        border: 1px solid #bfd0e0;
        border-radius: 8px;
        min-height: 28px;
        padding: 4px 8px;
        box-shadow: none;
      }

      .premium-table-wrapper .ReactTable .-pagination {
        box-shadow: none;
        border-top: 1px solid #e2e8f0;
        padding: 14px 18px;
        background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
      }

      .premium-table-wrapper .ReactTable .-pagination .-btn {
        min-width: 138px;
        height: 40px;
        border-radius: 12px;
        border: 1px solid #3c8dbc;
        background: #3c8dbc;
        color: #ffffff;
        font-weight: 600;
        box-shadow: 0 10px 20px rgba(60, 141, 188, 0.18);
        transition: all 0.2s ease;
      }

      .premium-table-wrapper .ReactTable .-pagination .-btn[disabled] {
        background: #9fc4da;
        border-color: #9fc4da;
        color: rgba(255, 255, 255, 0.92);
        box-shadow: none;
        opacity: 1;
        display: none;
      }

      .premium-table-wrapper .ReactTable .-pagination .-btn:not([disabled]):hover {
        transform: translateY(-1px);
        box-shadow: 0 12px 24px rgba(60, 141, 188, 0.22);
      }

      .premium-table-wrapper .ReactTable .-pagination .-center {
        color: #475569;
        font-weight: 600;
        font-size: 14px;
      }

      .premium-table-loading-overlay {
        position: absolute;
        inset: 0;
        background: rgba(255, 255, 255, 0.82);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 5;
        backdrop-filter: blur(1px);
      }

      .premium-table-loading-content {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 12px 16px;
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.96);
        border: 1px solid rgba(191, 208, 224, 0.9);
        box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
        color: #475569;
        font-size: 14px;
        font-weight: 600;
      }

      @media (max-width: 767px) {
        .premium-table-toolbar {
          padding: 14px 14px 10px;
        }

        .premium-table-toolbar-actions {
          justify-content: flex-start;
        }

        .premium-table-wrapper {
          padding: 8px;
        }
      }
    `}</style>

    <div className="premium-table-shell">
      <div className="premium-table-card">
        {!hideToolbar && (
          <div className="premium-table-toolbar">
            <div className="premium-table-toolbar-title">
              <p>{summary}</p>
            </div>
            <div className="premium-table-toolbar-actions">{toolbarRight}</div>
          </div>
        )}

        <div className="premium-table-wrapper" style={{ '--premium-table-min-width': `${tableMinWidth}px` }}>
          {loading && (
            <div className="premium-table-loading-overlay">
              <div className="premium-table-loading-content">
                <i className="fa fa-spinner fa-spin" />
                <span>{loadingText}</span>
              </div>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  </>
);

export default PremiumTableShell;
